import React from "react";
import { useParams } from "react-router-dom";
import { useWorkflow } from "../contexts/WorkflowContext";
import CheckinLayout from "../components/CheckinLayout";

const Completion: React.FC = () => {
  // appointmentId currently unused but kept for future deep-link parity.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { appointmentId } = useParams<{ appointmentId: string }>();
  const { workflow, loading } = useWorkflow();

  return (
    <CheckinLayout
      title="Check-In Complete"
      subtitle="Thank you for completing your check-in"
      showProgress={false}
    >
        <div className="bg-white rounded-xl border border-[#A4BDC0] shadow-md p-10 w-full max-w-[600px] flex flex-col gap-6 mt-4">
          {loading ? (
            <div className="text-center text-[#5D6A85]">
              Loading...
            </div>
          ) : (
            <div className="flex flex-col gap-6">
              <div className="bg-[#E0F2F3] border border-[#01545D] rounded-lg px-6 py-5 flex items-center gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#01545D] flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="text-lg font-semibold text-[#01545D] mb-1">
                    All Steps Completed
                  </div>
                  <div className="text-sm text-[#1C1C1C]">
                    You have successfully completed all required check-in steps.
                  </div>
                </div>
              </div>

              <div className="text-center">
                <p className="text-lg text-[#1C1C1C] mb-2">
                  Your information has been saved successfully.
                </p>
                <p className="text-sm text-[#5D6A85]">
                  You're all set for your appointment. We look forward to seeing you!
                  Please arrive 15 minutes early to your appointment. Note that we have a 10-minute late policy. Arrivals past this window will need to be rescheduled.
                </p>
              </div>

              {workflow?.steps && workflow.steps.length > 0 && (
                <div className="border-t border-[#A4BDC0] pt-6">
                  <div className="text-sm font-semibold text-[#1C1C1C] mb-3">
                    Completed Steps:
                  </div>
                  <div className="flex flex-col gap-2">
                    {workflow.steps.map((step) => (
                      <div
                        key={step.id}
                        className="flex items-center gap-2 text-sm text-[#5D6A85]"
                      >
                        <svg className="w-4 h-4 text-[#22C55E] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span>{step.stepName}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
    </CheckinLayout>
  );
};

export default Completion;
